import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloClient, ApolloProvider, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import App from './App';
import { cache } from "./cache";
import { authWrapper } from './Auth/msauth';

const httpLink = createHttpLink({
  uri: process.env['REACT_APP_GRAPHQL_SERVER'],
});


// async function to generate headers
const accessToken = async (headers: any) => {
  // get the authentication token from local storage if it exists
  const token = await authWrapper().then(resp => resp);
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token.accessToken}` : "",
    }
  }
}

const authLink = setContext((_, { headers }) => {
  // call async function and return JWT header
  return accessToken(headers).then((authHead) => authHead)
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: cache
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
